import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

type PopoverManagerContextType = {
    content: JSX.Element | null
    showPopover: (content: JSX.Element) => void
    hidePopover: () => void
}

const PopoverManagerContext = createContext<PopoverManagerContextType>(null!)

export const PopoverManagerProvider = ({ children }: { children: React.ReactNode }) => {
    const [content, setContent] = useState<JSX.Element | null>(null)

    const showPopover = useCallback((newContent: JSX.Element) => {
        setContent(newContent)
    }, [])

    const hidePopover = useCallback(() => {
        setContent(null)
    }, [])

    const value = useMemo(
        () => ({ content, showPopover, hidePopover }),
        [content, showPopover, hidePopover]
    )

    return <PopoverManagerContext.Provider value={value}>{children}</PopoverManagerContext.Provider>
}

export const usePopoverManagerContext = () => {
    return useContext(PopoverManagerContext)
}
